"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

interface TabsProps {
  items: string[];
  children: React.ReactNode;
  className?: string;
}

function Tabs({ items, children, className }: TabsProps) {
  const [active, setActive] = React.useState(0);
  const panels = React.Children.toArray(children);

  return (
    <div className={cn("my-6", className)}>
      <div className="flex gap-1 border-b overflow-x-auto">
        {items.map((label, i) => (
          <button
            key={label}
            onClick={() => setActive(i)}
            className={cn(
              "whitespace-nowrap px-4 py-2 text-sm font-medium transition-colors rounded-t-md",
              active === i
                ? "border-b-2 border-primary text-foreground bg-muted/50"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/30",
            )}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="pt-4">
        {panels.map((panel, i) => (
          <div key={i} className={active === i ? "block" : "hidden"}>
            {panel}
          </div>
        ))}
      </div>
    </div>
  );
}

function Tab({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}

export { Tabs, Tab };
